<template>
<div id="container_app">
   <div class="locationWrap support">
     <div>
       <span class="inner aniBox type_right gogo"><span>D</span>ata <br><span>A</span>nalysis <br><span>M</span>arketplace for <br><span>D</span>ata<br><span>A</span>lliance</span>
       <strong class="inner locTit aniBox type_bot gogo">
         <p class="">데이터로 가치를 담다. 혁신을 담다. 비전을 담다.</p>이용안내
       </strong>
     </div>
   </div>
   <div class="contents">
     <div class="inner">
       <div class="subTitWrap aniBox type_left gogo">
         <h2>FAQ</h2>
       </div>

       <div class="qnaWrap">
         <form name="frm_search" @submit.prevent="loadData()">
         <div class="topSearchArea clearfix">
           <div class="topSearch clearfix">
             <select name="search_field" id="" class="select_ty1" v-model="searchOpt.keyType">
               <option value="01">전체</option>
               <option value="02">질문</option>
               <option value="03">답변</option>
             </select>
             <div class="inputBox">
               <input type="text" class="input_ty1" name="search_keyword" value="" v-model="searchOpt.keyWord" >
               <input type="button" class="btn_search" value="" @click="loadData()">
             </div>
           </div>
         </div>
         </form>

        <faqtabs>
            <faqtab :name="listItem.codeName" :cnt="listItem.cnt" v-for="(listItem, index) in gridData" :key="listItem.keyid" :selected='index===0?true:false'>
              <div class="toggleList">
                <dl class="aniBox type_right gogo" v-for="faqInfo in listItem.faqList" :key="faqInfo.keyid">
                  <dt class="">
                    <strong class="tit" v-text="faqInfo.title"></strong>
                  </dt>
                  <dd style="display: none;">
                    <div class="a_cont" v-html="cvtText(faqInfo.contents)">
                    </div>
                  </dd>
                </dl>
                <div class="searchNothing" v-if="listItem.faqList.length===0">
                  <img src="/static/images/contents/icon_info.png" alt="">
                  <p>조회 결과가 없습니다.</p>
                </div>
            </div>
          </faqtab>
        </faqtabs>
         <div class="questionBox bg_gray aniBox type_bot gogo">
           <strong>찾으시는 정보가 없으신가요?</strong>
           <p>1:1 문의를 통해 문의 내용을 접수해 주시면 친절하게 안내해 드립니다.</p>
           <button @click="goToQna()">1:1 문의하기</button>
         </div>
       </div>
     </div>
   </div>
 </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
import $ from 'jquery'

Vue.component('faqtabs', {
  template: `
  <div class="tabs">
    <div class="faqTab">
      <ul class="mv_menu col4 clearfix aniBox gogo">
        <li v-for="tab in tabs">
          <a :href="tab.href" @click="selectTab(tab)" :class="{ 'active' : tab.isActive }">
            <p>{{ tab.name }}<span>[{{ tab.cnt }}건]</span></p>
          </a>
        </li>
      </ul>
    </div>
    <div class="tabs-details"><slot></slot></div>
  </div>
  `,

  data () {
    return {
      tabs: []
    }
  },

  created () {
    this.tabs = this.$children
  },

  methods: {
    selectTab (selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = (tab.name === selectedTab.name)
      })
    }
  },
  mounted () {
  }
})

Vue.component('faqtab', {
  template: `
    <div v-show="isActive"><slot></slot></div>
  `,

  props: {
    name: {
      required: true
    },
    cnt: {
      required: true
    },
    selected: {
      default: false
    }
  },

  data () {
    return {
      isActive: false
    }
  },

  computed: {
    href () {
      return '#' + this.name.toLowerCase().replace(/ /g, '-')
    }
  },

  mounted () {
    var _this = this
    _this.isActive = _this.selected
  },
  updated () {
    this.$nextTick(function () {
      $('.toggleList dl dt').unbind('click')
      /*
      $('.toggleList dl').eq(0).find('dd').show()
      $('.toggleList dl').eq(0).addClass('on')
      $('.toggleList dl').eq(0).find('dt').addClass('on')
      */
      $('.toggleList dl dt').click(function () {
        if ($(this).hasClass('on')) {
          $(this).parent('dl').removeClass('on')
          $(this).removeClass('on')
          $(this).next('dd').slideUp(200)
        } else {
          $(this).parent('dl').addClass('on')
          $(this).addClass('on')
          $(this).next('dd').slideDown(250)
        }
      })
    })
  }
})

export default {
  name: 'SupportFaq',
  data () {
    return {
      gridData: [],
      pageInfo: [],
      searchOpt: {
        keyWord: '',
        keyType: '01'
      }
    }
  },
  methods: {
    dateFmt (dt) {
      return moment(dt).format('YYYY-MM-DD')
    },
    loadData () {
      var _this = this
      var params = {
        keyType: _this.searchOpt.keyType,
        keyWord: _this.searchOpt.keyWord
      }
      axios.get('/web/api/board/FAQ', {withCredentials: true, params: params})
        .then(response => {
          this.gridData = response.data.result
        })
        .catch(e => {
          console.log('error : ', e)
        })
    },
    goToQna () {
      this.$router.push('/support/qna')
    },
    cvtText (val) {
      return val.replace('pencake', 'web')
    }
  },
  created () {

  },
  mounted () {
    this.loadData()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SupportFaq.vue